import { PublicKey, SystemProgram } from '@solana/web3.js';
import idl from '../../helper/idl.json';
import { getPhantomProvider } from '../../helper/solana';
import { getSolanaConnection } from '../connection';
import { PROGRAM_ID } from '../programConstants';

export const TOKEN_PROGRAM_ID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
export const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey(
  'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'
);

const textEncoder = new TextEncoder();

function getInstructionDefinition(name) {
  return idl.instructions.find((instruction) => instruction.name === name) || null;
}

export async function getInstructionDiscriminator(name) {
  const preimage = textEncoder.encode(`global:${name}`);
  const digest = await window.crypto.subtle.digest('SHA-256', preimage);

  return new Uint8Array(digest).slice(0, 8);
}

export function getPlatformTreasuryPda() {
  const [publicKey] = PublicKey.findProgramAddressSync([textEncoder.encode('treasury')], PROGRAM_ID);

  return publicKey;
}

export function getMayhemProgram() {
  return {
    associatedTokenProgramId: ASSOCIATED_TOKEN_PROGRAM_ID,
    connection: getSolanaConnection(),
    getInstructionDefinition,
    getPhantomProvider: () => getPhantomProvider(),
    getPlatformTreasuryPda,
    idl,
    programId: PROGRAM_ID,
    systemProgramId: SystemProgram.programId,
    tokenProgramId: TOKEN_PROGRAM_ID,
  };
}
